import React from 'react';
import LazyLoad from 'react-lazyload';
import styles from '../index.module.scss';


function PopMenu(props) {

  const {
    hoverIndex,
    content: {
      subMenu = [],
      subBrands = [],
      subAd = []
    }
  } = props;


  return (
    <div className={styles["sub-menu"]}>
      <div className={styles["sub-list"]}>
        {
          subMenu.map((subMenuItem, subMenuItemIdx, subMenuArr) => {
            const title = subMenuItem?.text || '';
            const titleLink = subMenuItem?.linkText || '';
            const detailArr = subMenuItem?.popThreeCategory || [];
            return (
              <React.Fragment key={subMenuItemIdx}>
                <dl className={styles.slBlock}>
                  <dt className={styles.liTitle}>
                    <a href={titleLink} target="_blank" rel="noopener noreferrer" clstag={`firsttype|keycount|jdworldwidev2|fl${hoverIndex + 1}-p${subMenuItemIdx + 1}`}>
                      {title}
                    </a>
                  </dt>
                  {
                    detailArr.map((detailItem, detailItemIdx, arr) => {
                      const text = detailItem?.text || '';
                      const linkText = detailItem?.linkText || '';
                      return (
                        <dd className={styles.liItem} key={text}>
                          <a href={linkText} target="_blank" style={detailItemIdx === arr.length - 1 ? { borderRight: 0 } : null} rel="noopener noreferrer" clstag={`firsttype|keycount|jdworldwidev2|fl${hoverIndex + 1}-p${subMenuItemIdx + 1}-${detailItemIdx + 1}`}>
                            {text}
                          </a>
                        </dd>
                      )
                    })
                  }
                  <span className="clr"></span>
                </dl>
                {
                  subMenuItemIdx !== subMenuArr.length - 1 && <div className={styles.split}></div>
                }
              </React.Fragment>
            )
          })
        }
      </div>
      <div className={styles["sub-right"]}>
        <div className={styles["sr-mask"]}></div>
        <ul className={`${styles["sub-brands"]} clearfix`}>
          {
            subBrands.slice(0, 7).map((brand, brandIdx) => {
              const imgUrl = brand?.imgLogo || '';
              const linkUrl = brand?.linkText || '';
              return (
                <li key={brandIdx}>
                  <a href={linkUrl} target="_blank" rel="noopener noreferrer" clstag={`firsttype|keycount|jdworldwidev2|fl${hoverIndex + 1}-b${brandIdx + 1}`}>
                    <LazyLoad placeholder={imgUrl} scroll={true} overflow={true}>
                      <img src={imgUrl} alt="" />
                    </LazyLoad>
                  </a>
                </li>
              )
            })
          }
        </ul>
        {
          subAd.map((adItem, adIdx) => {
            const imgUrl = adItem?.actImg || '';
            const linkUrl = adItem?.linkText || '';
            return (
              <a target="_blank" href={linkUrl} key={adIdx} rel="noopener noreferrer" clstag={`firsttype|keycount|jdworldwidev2|fl${hoverIndex + 1}-ad`}>
                <LazyLoad placeholder={imgUrl} scroll={true} overflow={true}>
                  <img src={imgUrl} className={styles["sub-ad"]} alt="" />
                </LazyLoad>
              </a>
            )
          })
        }
      </div>
    </div>
  )
}

export default PopMenu;